import QuestionObj from "../Models/QuestionObj";

const Digimar_QSet = [
  new QuestionObj({
    questionSet: {
      English:
        "How effective is your SEO strategy?",
    },
    answerSet: {
      English: [
        "Not great. Our product pages struggle to rank well in organic search",
        "Somewhat effective. We’ve organized our products behind commonly searched terms which results in some organic search exposure",
        "Very effective. We have a strong metadata strategy that boosts our organic search visibility and drives site traffic",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How effectively can campaign managers seamlessly connect campaigns and customer journeys across marketing and commerce experiences?",
    },
    answerSet: {
      English: [
        "Not effectively. Our campaign management cannot connect into the commerce experience beyond simple landing pages",
        "We have some ability to connect commerce activities within our campaign designer, but it is through a custom integration that is costly to maintain",
        "Yes, we can seamlessly connect our customer’s commerce activities into our digital marketing campaign efforts to guide customers all the way to purchase with a consistent campaign experience",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Are your commerce teams able to access and utilize approved brand, campaign, and other marketing content and assets efficiently?",
    },

    answerSet: {
      English: [
        "No, we lack a central asset repository which results in frequent asks from our commerce team",
        "Somewhat, we create assets, which are then stored in a disconnected repository. This tends to create access and versioning issues",
        "Yes, we operate with an integrated content repository to easily share, manage, and maintain marketing assets",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How personalized is your customer’s buying experience?",
    },
    answerSet: {
      English: [
        "Generic, all customers receive the same digital experience, regardless of their relationship to us",
        "Mixed, the customer experience has some personalization based on real-time activities, such as browse and click data",
        "Unique, we create a personalized experience for every customer based on their real-time and lifetime engagement data",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Does your ecommerce platform use AI and/or machine learning to offer recommended products and services based on customers’ buying habits?",
    },
    answerSet: {
      English: [
        "No",
        "Somewhat, we recommend additional offerings on our ecommerce site, but we do not use AI or engagement data to tailor offerings to our buyers",
        "Yes",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Does your commerce solution support loyalty programs for frequent customer engagement?",
    },
    answerSet: {
      English: [
        "No, we currently do not offer any loyalty programs",
        "Yes. Our solution integrates with loyalty programs to attract and retain customers",
        "Boost engagement and customer lifetime value with a built-in loyalty framework.",
      ],
    },
    custVals: [25, 66, 100],
  }),
];

export default Digimar_QSet;
